import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateUser, logout } from "../Utils/Redux/UserSlice";
import cogoToast from 'cogo-toast-react-17-fix';
import { abortAllRequests } from '../Utils/AbortController';
import { AuthConsole, resetDocument } from '../Utils/helper';

const useRefreshToken = (refreshTokenEndpoint) => {
  const dispatch = useDispatch()
  const User = useSelector(state => state.User)
  const { access_token, user_email, expiry_time, refresh_token } = User
  const [accessToken, setaccessToken] = useState(access_token)

  const currentdate = new Date().toISOString()

  const sessionExpireLogout = async () => {
    cogoToast.info("Session Expired! Please log in again");
    abortAllRequests();
    await new Promise(resolve => setTimeout(resolve, 2000));
    resetDocument();
    window.location.reload();
    dispatch(logout());
  }

  const refreshAccessToken = async () => {
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    };
    try {
      const response = await fetch(refreshTokenEndpoint + refresh_token, requestOptions);
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      const data = await response.json();
      if (data.data == null) {
        AuthConsole("No Data, logging out")
        throw new Error(`Request failed with status ${response.status}`);
      }
      if (data.status == "200") {
        setaccessToken(data.data.access_token)
        dispatch(updateUser({
          access_token: data.data.access_token,
          refresh_token: data.data.refresh_token,
          expiry_time: data.data.expiry_time
        }));
      }
    }
    catch (error) {
      AuthConsole(error)
      if (error.message === 'Failed to fetch') {
        AuthConsole("Network error, Reloading")
      }
      else {
        sessionExpireLogout();
      }
    }
  };

  useEffect(() => {
    let timeoutId;
    const refreshDelay = 3000; // Adjust the debounce delay as needed

    const handleTokenRefresh = () => {
      if (currentdate > expiry_time) {
        AuthConsole("Logging Out Here");

        sessionExpireLogout();
      } else {
        refreshAccessToken();
      }
    };

    const debouncedRefresh = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(handleTokenRefresh, refreshDelay);
    };

    debouncedRefresh();

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return accessToken;
};

export default useRefreshToken;
